import React, { Fragment, useContext, useEffect, useState } from "react";
// Provider
import {
  AppContext,
  checkMobile,
  SET_ITEMSTATE,
  SET_PAGE_STATE,
} from "../../components/AppProvider";

// Utils
import {
  AlertLayer,
  AlertTelLayer,
  ConfirmLayer,
} from "../../components/UI/Dialog";
import {
  PostApi1940,
  PostApi1941,
  PostApi1942,
} from "../../modules/network/padoPost";
import { checkNum10 } from "../../modules/utils/CheckLogic";
import { NativeAction } from "../../modules/utils/HandleWs";
import { reLogin } from "../common/AutoLogin/AutoLogin";
import { MapView } from "../common/Modal/NaverMap";
import { closeLayerFn, Container, DateLayerHist, openLayerFn } from "../Layout";
import AddList, {
  Allim,
  Location,
  RepeatCustomLayer,
  RepeatLayer,
  TargetDateLayer,
} from "./AddList";
import Calendar from "./Calendar";
import ReserveList from "./ReserveList";
import TestHistory from "./TestHistory";
import useTitle from "../../modules/hooks/useTitle";

export default props => {
  useTitle("검사스케쥴_메인");
  const { userinfo, cfg, phonecfg, auth, dispatch, pageState, itemState } =
    useContext(AppContext);
  const [title, setTitle] = useState("START");

  const [selectHpNm, setSelectHpNm] = useState("");
  const [hpLat, setHpLat] = useState("");
  const [hpLon, setHpLon] = useState("");

  // I/F PARAMETER 1940
  const [schdlType, setSchdlType] = useState("T");
  const [loading, setLoading] = useState(true);

  const [schdlList, setSchdlList] = useState();
  const [schdlHistList, setSchdlHistList] = useState();
  const [checkedDate, setCheckedDate] = useState([]);
  // I/F PARAMETER 1940

  const [checkedSeqNo, setCheckedSeqNo] = useState("");
  const [calendar, setCalendar] = useState(true);

  const [locationInfo, setLocationInfo] = useState({});
  const [mode, setMode] = useState(true);

  const [tell, setTell] = useState();

  const [cancelTarget, setCancelTarget] = useState({});
  // 과거:P, 그 외:F
  const [periodState, setPeriodState] = useState("F");

  let userinfo2 = reLogin(auth, userinfo, dispatch);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
    handleConfirmCB: "",
  });

  const handleDialog = (title, msg, handleConfirmCB, param) => {
    setDialog({
      title: title,
      msg: msg,
      handleConfirmCB: handleConfirmCB,
    });

    openLayerFn($(".confirm-layer"));

    if (handleConfirmCB === "cancel") {
      setCancelTarget(param);
    }
  };
  // 다이얼로그 ]]

  let dateFrom = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    0
  );
  let dateTo = new Date(new Date().setDate(dateFrom.getDate() + 7));
  // let dateFrom = new Date(new Date().setMonth(dateFrom.getMonth() - 1)); -- 한달

  // let defaultFrom = dateFrom.getFullYear() + "." + checkNum10(dateFrom.getMonth()+1) + "." + checkNum10(dateFrom.getDate());
  // let defaultTo = dateTo.getFullYear() + "." + checkNum10(dateTo.getMonth()+1) + "." + checkNum10(dateTo.getDate());
  let defaultFrom =
    dateFrom.getFullYear() +
    "." +
    checkNum10(dateFrom.getMonth() + 1) +
    "." +
    "01";
  let defaultTo =
    dateFrom.getFullYear() +
    "." +
    checkNum10(dateFrom.getMonth() + 1) +
    "." +
    checkNum10(dateFrom.getDate());

  const mapLayer = locationInfo => {
    closeLayerFn($(".add-date-layer"));
    openLayerFn($(".map-view-layer"));
    NativeAction(phonecfg, "statusColor", "#FFFFFF");
    setLocationInfo(locationInfo);
  };

  const settingSeqNo = () => {
    let checkArr = new Array();

    $("input[name=checkSeqNo]:checked").each(function () {
      checkArr.push($(this).val());
    });
    setCheckedSeqNo(checkArr);
  };

  const unCheckedAll = () => {
    $("input:checkbox").prop("checked", false);
    settingSeqNo();
  };

  const Bottom = (
    <Fragment>
      <div className="allcheck-setting-area">
        <a onClick={unCheckedAll}>
          <i className="clear"></i>선택해제
        </a>
        <a
          className="btn-check-delete"
          onClick={() =>
            handleDialog(
              "검사예약삭제",
              "삭제시 선택하신 병원예약이 취소됩니다.<br /> 정말 삭제하시겠습니까?",
              "delete"
            )
          }>
          <i className="dele"></i>선택삭제
        </a>
      </div>
    </Fragment>
  );

  const request1940 = () => {
    PostApi1940(
      userinfo2,
      cfg,
      phonecfg,
      schdlType,
      $(".pick-num1").val().split(".").join(""),
      $(".pick-num2").val().split(".").join("")
    )
      .then(res => {
        if (res.resultMsg === "SUCCESS") {
          let data = res.result;
          let schdlDate = [];

          if (data.length > 0) {
            // 과거, 미래 구분
            // 년도, 월로 현재날짜만 추출
            data.map(m => {
              if (
                parseInt(m.schdlDh.split(".")[0] + m.schdlDh.split(".")[1]) ==
                parseInt(
                  $(".pick-num1").val().split(".")[0] +
                    $(".pick-num1").val().split(".")[1]
                )
              ) {
                schdlDate.push({
                  date: parseInt(m.clndVal),
                  desc: m.schdlNm,
                });
              }
            });

            setCheckedDate(schdlDate);
            // setSchdlList(data);
            setSchdlList(data.filter(data => data.timeType === "F"));
            setSchdlHistList(data.filter(data => data.timeType === "P"));
          } else {
            setCheckedDate(schdlDate);
            setSchdlList([]);
            setSchdlHistList([]);
          }
        } else {
          console.log("LOGOUT!!!");
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // 삭제 인터페이스
  // 기간이 지났거나, 예약이 취소된 목록
  const request1941 = seqNo => {
    PostApi1941(userinfo, cfg, phonecfg, seqNo)
      .then(res => {
        setLoading(true);
        unCheckedAll();
        $(".infobox").css("backgroundColor", "#fff");
      })
      .catch(err => {});
  };

  // 예약 취소 인터페이스
  const request1942 = () => {
    PostApi1942(
      userinfo,
      cfg,
      phonecfg,
      cancelTarget.schdlSeqNo,
      cancelTarget.hsptCd,
      cancelTarget.schdlNo
    )
      .then(res => {
        setLoading(true);
      })
      .catch(err => {});
  };

  const deleteReserveList = () => {
    let rtnValue = [];
    $('input:checkbox[name="checkSeqNo"]').each(function () {
      if (this.checked) {
        rtnValue.push(this.value);
      }
    });

    if (rtnValue.length > 0) {
      // confirm 창 추가
      // 삭제한 목록은 표시되지 않습니다 정말 삭제 하시겠습니까?
      request1941(rtnValue);
    } else {
      handleDialog("", "삭제할 대상을 선택하세요", "delete");
    }
  };

  useEffect(() => {
    // 지도 닫기
    $(".map-view-layer .btn-closex").click(function () {
      closeLayerFn($(".map-view-layer"));
    });

    // 최초날짜 등록
    $(".pick-num1").val(defaultFrom);
    $(".pick-num2").val(defaultTo);
  }, []);

  useEffect(() => {
    if (checkedSeqNo == "") {
      $(".calendar-reser-date").css({ marginBottom: "0px" });
      $(".allcheck-setting-area").hide();
    } else {
      $(".calendar-reser-date").css({ marginBottom: "40px" });
      $(".allcheck-setting-area").show();
    }
  }, [checkedSeqNo]);

  useEffect(() => {
    if (props.match.params.targetDate) {
      let pushDate = new Date(props.match.params.targetDate);

      let pushFrom =
        pushDate.getFullYear() +
        "." +
        checkNum10(pushDate.getMonth() + 1) +
        "." +
        "01";
      let pushTo =
        pushDate.getFullYear() +
        "." +
        checkNum10(pushDate.getMonth() + 1) +
        "." +
        new Date(pushDate.getFullYear(), pushDate.getMonth() + 1, 0).getDate();

      $(".pick-num1").val(pushFrom);
      $(".pick-num2").val(pushTo);

      setLoading(true);
    }
  }, [props.match.params.targetDate]);

  useEffect(() => {
    if (calendar) {
      if (loading) {
        request1940();
        setLoading(false);
        setCalendar(true);
      }
    }

    if (
      parseInt(
        $(".pick-num1").val().split(".")[0] +
          $(".pick-num1").val().split(".")[1] +
          $(".pick-num1").val().split(".")[2]
      ) <
      parseInt(defaultFrom.split(".")[0]) +
        defaultFrom.split(".")[1] +
        defaultFrom.split(".")[2]
    ) {
      setPeriodState("P");
    } else {
      setPeriodState("F");
    }
  }, [loading, calendar]);

  useEffect(() => {
    if (checkedSeqNo == "") {
      $(".allcheck-setting-area").hide();
    } else {
      $(".allcheck-setting-area").show();
    }
  }, [checkedSeqNo]);

  useEffect(() => {
    if (checkMobile() === "ANDROID") {
      // window.java.rcvFromWeb("wn111");
    } else if (
      checkMobile() === "IOS" &&
      parseInt(phonecfg.version.split(".")[2]) >= 25
    ) {
      webkit.messageHandlers.rcvFromWeb.postMessage({
        command: "wn111",
        data: "wn111",
      });
    }
  }, []);

  useEffect(() => {
    NativeAction(phonecfg, "statusColor", "#b2bee6");
  }, [loading]);

  useEffect(() => {
    if (pageState.reload || itemState.reload) {
      setLoading(true);

      if (pageState.reload) {
        dispatch({
          type: SET_PAGE_STATE,
          data: { type: "reload" },
        });
      }

      if (itemState.reload) {
        dispatch({
          type: SET_ITEMSTATE,
          data: { type: "RELOAD" },
        });
      }
    }
  }, [pageState.reload, itemState.reload]);

  return (
    <Fragment>
      <Container Title="검사 스케쥴" bottom={Bottom} goToUrl="/">
        {/* <div className="contents sub grad" style={{'backgroundSize':'845px 82px'}}> */}
        <div className="contents sub grad">
          <div
            className="sub-contents"
            style={{
              padding: "25px 20px 50px",
            }}>
            {/* submenu -> 날짜 from ~ to */}
            <div className="select-date-area" style={{ padding: "0" }}>
              <div className="round-bar purple">
                <div className="ipbox">
                  <input
                    type="text"
                    placeholder="선택하세요."
                    readOnly
                    className="date-picker-input pick-num1"
                    data-num="1"
                  />
                  <i></i>
                </div>
                <u>~</u>
                <div className="ipbox">
                  <input
                    type="text"
                    placeholder="선택하세요."
                    readOnly
                    className="date-picker-input pick-num2"
                    data-num="2"
                  />
                  <i></i>
                </div>
              </div>
            </div>
            {/* calendar (slick) */}
            {calendar && (
              <Calendar
                setLoading={setLoading}
                checkedDate={checkedDate ? checkedDate : []}
              />
            )}

            {/* 이달의 경과 검사 START */}
            {schdlHistList &&
              schdlHistList.length > 0 &&
              periodState === "F" && (
                <TestHistory>
                  <ReserveList
                    mapLayer={mapLayer}
                    settingSeqNo={settingSeqNo}
                    calendar={calendar}
                    schdlList={schdlHistList}
                    handleDialog={handleDialog}
                    mode={mode}
                    keyName={"hist"}
                  />
                </TestHistory>
              )}
            {/* 이달의 경과 검사 END */}

            {/* 예약현황 */}
            {
              // schdlList && <ReserveList mapLayer={mapLayer} settingSeqNo={settingSeqNo} calendar={calendar} schdlList={periodState === "F" ? schdlList : schdlHistList} handleDialog={handleDialog} mode={mode} keyName={"future"} periodState={periodState} />
              schdlList && (
                <ReserveList
                  mapLayer={mapLayer}
                  settingSeqNo={settingSeqNo}
                  calendar={calendar}
                  // schdlList={schdlList}
                  schdlList={periodState === "F" ? schdlList : schdlHistList}
                  handleDialog={handleDialog}
                  mode={mode}
                  keyName={"future"}
                  periodState={periodState}
                />
              )
            }
          </div>
        </div>
      </Container>
      {/* 날짜선택 레이어 */}
      <DateLayerHist
        id={"Schedule"}
        setCalendar={setCalendar}
        setLoading={setLoading}
      />
      {/* 일정추가 레이어 */}
      <RepeatLayer />
      <RepeatCustomLayer />
      <Location />
      <Allim />
      <TargetDateLayer title={title} />
      <AddList setTitle={setTitle} handleDialog={handleDialog} />
      {/* 지도 API */}
      <MapView locationInfo={locationInfo} />

      <AlertLayer
        title={dialog.title}
        msg={dialog.msg}
        handleConfirmCB={() => closeLayerFn(".alert-layer")}
      />
      <AlertTelLayer tel={tell} />
      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={() => closeLayerFn($(".confirm-layer"))}
        handleConfirmCB={
          dialog.handleConfirmCB === "delete" ? deleteReserveList : request1942
        }
      />
    </Fragment>
  );
};
